import React from "react";
import { Link } from "react-router-dom";
import { Dots } from "react-dot-patterns";
import heroSectionImage from "../../../assets/service-hero-image.jpg";

const HeroSection = () => {
  return (
    <div className="pharmaceutical-hero-section-wrapper">
      <div className="dots1">
        <Dots
          col={6}
          row={4}
          size={5}
          rotate={0}
          margin={8}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={10}
        />
      </div>
      <div className="dots2">
        <Dots
          col={3}
          row={4}
          size={5}
          rotate={0}
          margin={5}
          color={"#f3792c"}
          item={null}
          style={{}}
          evenRowShift={-20}
        />
      </div>
      <div className="row">
        <div className="col-12 col-md-6 p-4">
          <div className="detail-container">
            <h1>
              Ensure Compliance
              <br /> and <span>Streamline Pharmaceutical</span>
              <br /> Operations
            </h1>
            <p>
              The pharmaceutical industry is highly regulated, with strict
              compliance requirements and complex supply chains. Soori
              Corporation provides robust software solutions that help
              pharmaceutical companies ensure compliance, manage assets, and
              optimize production processes.
            </p>
            <Link to="/services">Book A Meeting</Link>
          </div>
        </div>
        <div className="col-12 col-md-6 p-4">
          <div className="image-container">
            <img src={heroSectionImage} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;
